module.exports = __webpack_public_path__ + "img/androidProject.447c91a8.svg";